import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { pathname } = useLocation();

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-100 border-b border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex flex-wrap items-center text-sm gap-1">
          <li className="flex items-center">
            <Link
              to="/"
              className="text-secondary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
            >
              <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
              <span className="sr-only">首页</span>
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1">
              <i className="ri-arrow-right-s-line text-secondary-400 w-4 h-4 flex items-center justify-center"></i>
              {item.href && index < items.length - 1 ? (
                <Link
                  to={item.href}
                  className="text-secondary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={`whitespace-nowrap ${index === items.length - 1 ? 'text-foreground-800 font-medium' : 'text-secondary-500'}`}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}